import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";

import { headerWrapperStyles, headerStyles, titleStyles, logoStyles, headerButtonStyles} from "./styles/Header.styles";

export const Header = ({ conversationState, conversationSid }: { conversationState?: boolean; conversationSid?: string }) => {
    const handleEndChat = async () => {
        if(conversationState){
            const url=process.env.REACT_APP_END_CONVERSATION_URL;           
           
            try {
              const response = await fetch(`${url}?conversationSid=${conversationSid}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
              });
      
              if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
              }
      
              const data = await response.json();
              console.log('Response data:', data);
            } catch (error) {
              console.error('Error:',error);
            }
        }
        
    }

    return (
        <Box
        backgroundImage={headerWrapperStyles.backgroundImage}
        backgroundRepeat={headerWrapperStyles.backgroundRepeat}
        backgroundSize={headerWrapperStyles.backgroundSize}
        backgroundPosition={headerWrapperStyles.backgroundPosition}
        >
        <Box 
            padding={headerStyles.padding}
            style={headerStyles.style}
            alignItems={headerStyles.alignItems}
            justifyContent={headerStyles.justifyContent}
        >
            <Text 
                as="h1"
                fontSize={titleStyles.fontSize}
                style={titleStyles.style}
                fontWeight={titleStyles.fontWeight}
            >
                Philips TV Live Chat
            </Text>
            <img 
                className="velaro-header-logo" 
                src="https://galleryuseastprod.blob.core.windows.net/logos/EngagementConfiguration/20881/7163/8f452_Philips Logo.JPG" 
                alt=""
                role="presentation"
                width={logoStyles.width}
                height={logoStyles.height}
                style={logoStyles.style}
            />
            {conversationState ?<button
                        data-test="end-chat-button"
                        style={headerButtonStyles}                         
                        type="submit"
                        onClick={handleEndChat}
                        title="End Chat"
                    >&#x2715;                      
                    </button>:<></>}
        </Box>
        
        </Box>
    );
};
